import HelpTextIcon from "../../../Components/InformationIcon";

function LogTradeStepTwo({
    configuration,
    handleChange,
    initiateLoginProgress,
    activationProgress,
}) {
    return (
        <div>
            <h3 className="text-2xl font-semibold mb-8">
                Steg 2 -{" "}
                <span className="text-lg font-medium text-accent">
                    Aktivera LogTrade
                </span>
            </h3>

            {!configuration.extensionId ? (
                <>
                    <ul className="text-md font-medium list-disc list-outside pl-6 space-y-4">
                        <li>
                            Nu när förberedelserna är slutförda, logga in med
                            ert LogTrade-konto för att aktivera kopplingen.
                        </li>
                        <li>
                            Ange ert företagsnamn i fältet nedan.
                            <div className="flex items-start mt-2">
                                <label
                                    htmlFor="companyName"
                                    className="block font-medium"
                                >
                                    Företagsnamn
                                </label>
                                <HelpTextIcon infoText="Ange företagets namn, t.ex.: 'Zendr Aktiebolag'." />
                            </div>
                            <input
                                type="text"
                                name="companyName"
                                value={configuration.companyName}
                                onChange={handleChange}
                                className="w-96 p-2 mt-2 h-10 border border-gray-300 rounded-md"
                                required
                            />
                        </li>
                        <li>Klicka på "Logga in" för att fortsätta.</li>
                    </ul>
                    <div className="mt-6">
                        <button
                            className="c-button c-button--raised ml-6 w-60"
                            onClick={initiateLoginProgress}
                            disabled={
                                !configuration.companyName.trim() ||
                                activationProgress
                            }
                        >
                            Logga In
                        </button>
                    </div>
                </>
            ) : (
                <>
                    <p className="text-green-600 font-semibold mb-4">
                        Inloggningen lyckades!
                    </p>
                    <ul className="text-md font-medium list-disc list-outside pl-6 space-y-4">
                        <li>
                            Er LogTrade-integration är nu aktiverad och redo att
                            användas.
                        </li>
                        <li>
                            Tryck på <strong>Slutför</strong> för att gå vidare
                            och påbörja import av ordrar.
                        </li>
                    </ul>
                </>
            )}
        </div>
    );
}

export default LogTradeStepTwo;
